import {useEffect, useState} from "react";
import associateServices from "../../../services";
import {useSelector} from "react-redux";
import HomepageCasinoGroupItem from "./item";

import BlackjackGames from "../../../components/blackjack-games";
import RouletteGames from "../../../components/roulette-games";
import BaccaratGames from "../../../components/baccarat-games";
import TableGames from "../../../components/table-games";
import Loading from "../../../components/loading";

const generalGroups = {}
const LiveCasinoLobbyGroups = () => {
    const {activeLanguage} = useSelector(state => state.globalReducer)

    const [groups, setGroups] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        // todo get homepage groups !

        if (generalGroups[activeLanguage.key]) {
            setGroups(generalGroups[activeLanguage.key])
            setLoading(false)
        } else
            associateServices.getLiveLobbyGameGroups({
                language: activeLanguage?.key,
            }).then(res => {
                setGroups(res?.data || [])
                generalGroups[activeLanguage.key] = res?.data || null
                setLoading(false)

            })
    }, [activeLanguage?.key])


    return (
        <>
            {

                loading ? <Loading/> : groups?.length >= 1 ?
                    groups?.map(group =>
                        <HomepageCasinoGroupItem
                            key={group?.id}
                            path={group?.slug} image={group?.image}
                            title={group?.title} data={group?.group}/>
                    )
                    :
                    <>
                        <div className="section pt-24">
                            <div className="container">
                                <TableGames/>
                            </div>
                        </div>


                        <div className="section">
                            <div className="container">
                                <BlackjackGames/>
                            </div>
                        </div>

                        <div className="section">
                            <div className="container">
                                <RouletteGames/>
                            </div>
                        </div>


                        <div className="section">
                            <div className="container">
                                <BaccaratGames/>
                            </div>
                        </div>

                    </>
            }
        </>
    )

}

export default LiveCasinoLobbyGroups
